import { CrewMerchantUi } from 'corso-types';

import { Alert, OrderLineItem } from 'corso-admin-ui';
import { useCurrency } from '~/hooks/useCurrency';

export default function ClaimLineItem({
  claimLineItem,
}: {
  claimLineItem: CrewMerchantUi.ClaimLineItem;
}) {
  const { originalStoreOrderLineItem: orderLineItem } = claimLineItem;
  const { currencyCode } = useCurrency();

  return (
    <div className="flex flex-col gap-4 text-sm">
      {claimLineItem.errors?.map((error, index) => (
        <Alert
          // oxlint-disable-next-line react/no-array-index-key
          key={`${claimLineItem.id}-error-${index}`}
          variant="warning"
          heading={error}
        />
      ))}

      <OrderLineItem
        sku={orderLineItem.sku}
        src={orderLineItem.imgUrl}
        title={orderLineItem.name}
        options={orderLineItem.optionsFromPlatform}
        price={{
          currencyCode,
          unitPrice: claimLineItem.unitPrice,
          unitTax: claimLineItem.unitTax,
        }}
        quantity={claimLineItem.quantity}
      />
    </div>
  );
}
